import App from '../App';

// Export the App component as FormBuilderSuite for the library
export const FormBuilderSuite = App;

export default FormBuilderSuite;
